<template>
    <div class="body">
        <div class="addDepartment">
            <el-form ref="form" :model="form" class="form" label-width="100px">
                <el-form-item label="部门名称:">
                    <el-input v-model="form.name" :disabled="basicInfo"></el-input>
                </el-form-item>
                <el-form-item label="部门简称:">
                    <el-input v-model="form.acronym" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="负责人提成比:">
                    <el-input v-model="form.deptBonusRatio" :disabled="basicInfo"></el-input>
                </el-form-item>
                <el-form-item label="员工提成比:">
                    <el-input v-model="form.staffBonusRatio" :disabled="basicInfo"></el-input>
                </el-form-item>
                <el-form-item label="上级部门:">
                    <el-input v-model="form.prentName" :disabled="true"></el-input>
                    <!-- <el-cascader class="selectInput" :options="departLists" @change="departSend"  v-model="form.prentIds"  :props="{ multiple: false, checkStrictly: true ,value:'id',label:'name',children:'sub'}" clearable></el-cascader> -->
                </el-form-item>
                <el-form-item label="部门城市:" >
                    <el-input v-model="form.cityName" :disabled="true"></el-input>
                    <!-- <el-select class="selectInput" v-model="form.cityId" filterable :filter-method="searchCity" placeholder="请搜索">
                         <el-option  v-for="item in city" :key="item.value" :label="item.name"  :value="item.id"></el-option>
                    </el-select> -->
                </el-form-item>
                <el-form-item label="部门负责人:">
                    <el-select class="selectInput" :disabled="basicInfo" v-model="form.staffCode" filterable :filter-method="searchStaff" placeholder="请搜索">
                         <el-option  v-for="item in staff" :key="item.value" :label="item.name"  :value="item.jobNumber"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="网页权限">
                    <!-- <el-checkbox-group  @change="webChange"> -->
                    <el-checkbox v-for="(item,index) in form.web" :disabled="jurisdiction" v-model="item.possess" :key="index" :label="index"  name="type">{{item.name}}</el-checkbox>
                    <!-- </el-checkbox-group> -->
                </el-form-item>
                <el-form-item label="APP权限">
                    <!-- <el-checkbox-group  @change="appChange"> -->
                    <el-checkbox v-for="(item,index) in form.cms" :disabled="jurisdiction" v-model="item.possess" :key="index" :label="index" name="type">{{item.name}}</el-checkbox>
                    <!-- </el-checkbox-group> -->
                </el-form-item>
                <el-form-item>
                    <el-button type="primary"  @click="onSubmit">{{buttonTitle}}</el-button>
                    <el-button type="danger"  @click="onDelete">删除</el-button>
                </el-form-item>
                </el-form>

                <el-dialog  title="请选择需要编辑的类型" :visible.sync="dialogVisible" width="30%" >
                    <span>
                         <el-button @click="choice(0)">基本信息</el-button>
                        <el-button type="primary" @click="choice(1)">权限信息</el-button>
                    </span>
                </el-dialog>

        </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        form: {
          name: null,
          acronym:null,
          prentIds:null,
          prentId: null,
          cityId: null,
          staffCode: null,
          web: [],
          cms: [],
          webs:[],
          cmss:[],
          type:null,
        },
        staff:[],
        city:[],
        departId:null,
        web:null,
        cms:null,
        display:'none',
        departLists:[],

        basicInfo:true,
        jurisdiction:true,
        buttonTitle:'编辑',
        dialogVisible:false,

      }
    },
    onLoad(option){
        console.log("23131")
        console.log(option.id)

    },
    created() {
      //监听游览器后退事件
      if (window.history && window.history.pushState) {
        history.pushState(null, null, document.URL)
        window.addEventListener('popstate', this.departBack, false)
      }
    },
    destroyed() {
      window.removeEventListener('popstate', this.departBack, false)
    },
    mounted(){
        this.departInfo()
    },
    methods: {
      departBack(){
        this.$router.replace({path:"departMent"})
      },
      //选择
      choice(type){
          this.form.type = type
          this.buttonTitle = '保存'
          if(type==0){
            console.log("基本信息")
            this.basicInfo =false
          }else{
            console.log("权限信息")
            this.jurisdiction = false
          }
          this.dialogVisible  = false
      },
      //部门详情
      departInfo(){
          console.log(this.$route.query)
          this.joker.department.departInfo(this.$route.query.id).then(res=>{
              console.log(res)
              this.form = res.content
          })
      },
      //删除部门
      onDelete(){
          this.joker.department.departDelete(this.$route.query.id).then(res=>{
              console.log(res)
          })
      },
      //保存
      onSubmit() {
        if(this.form.type==null){
            this.dialogVisible  = true
        }else{
            if(this.form.type==0){
                console.log("基本保存")
                this.basicInfo = true
            }else if(this.form.type==1){
                console.log("权限保存")
                this.jurisdiction = true
            }
                this.joker.department.departUpdate(this.form).then(res=>{
                    console.log(res)
                    alert('修改成功')
                    this.form.type = null
                    this.buttonTitle = '编辑'
                })
        }
      },
      //网页权限
      webChange(value) {
          console.log(value)
          console.log(this.web[0])
          var list = []
          value.forEach(s => {
              console.log(s)
              list.push(this.web[s])
          });
          console.log(list)
          this.form.web = list
      },
      //APP权限
      appChange(value){
          console.log(value)
          var list = []
          value.forEach(s => {
              list.push(this.cms[s])
          });
          this.form.cms = list
      },

      //员工选择
      searchStaff(e){
          console.log(e)
          if(e!=''){
            this.joker.department.searchStaff(e).then(res=>{
              console.log(res)
              this.staff = res.content
            })
          }
      },
      //城市选择
      searchCity(e){
          console.log(e)
          if(e!=''){
            this.joker.department.searchCity(e).then(res=>{
                console.log(res)
                this.city = res.content
            })
          }

      },
      //部门列表
      departList(){

          this.joker.department.departList().then(res=>{
              console.log(res)
              this.departLists = res.content
          })
      },
      //选择部门
      departSend(e){
          console.log(e)
          if(e.length==1){//总部
                this.display = 'block'
          }else{
                this.display = 'none'
          }
          this.form.prentId = e.pop()
      },
      //权限列表
      groupList(){
          this.joker.department.groupList().then(res=>{
              console.log(res)
              this.web = res.content.web
              this.cms = res.content.cms
          })
      },
    }
  }
</script>


<style scoped>
.addDepartment{
    background-color: #FFFFFF;
    width: 98%;
    margin-left: 1%;
    margin-top: 1%;
    border-radius: 10px;
}
.form{
    width: 40%;
    margin-left: 30%;
    padding-top: 5%;
    padding-bottom: 5%;
}
.selectInput{
    width: 100%;
}
.send{
    width: 60%;
}
</style>



// WEBPACK FOOTER //
// src/components/Department/departmentInfo.vue